import { useListReportingGroups } from "#hooks/adapters/useReportingGroups";
import { AssetDetailsFormStep } from "#src/batteries-included-components/Panels/FormPanels/AssetDetailsFormPanel/AssetDetailsFormStep";
import { useListCustomAttributes } from "#src/components/hooks/adapters/useCustomAttributes";
import { AssetType, AttributeDataType, Resources } from "@validereinc/domain";
import { AssetGroups } from "@validereinc/domain-controllers";
import React from "react";

const { AssetGroupStatusOptions, NetworkMeasurementTypeOptions } =
  AssetGroups.view;

export const NetworkDetailsStep = () => {
  const { data: customAttributesData } = useListCustomAttributes({
    filters: { entity_type: AssetType.ASSET_GROUP },
  });
  const customAttributes = customAttributesData?.data ?? [];
  const reportingGroups = (useListReportingGroups().data as any)?.data ?? [];

  const staticFieldsToDisplay = [
    {
      field_name: "status",
      display_name: "Status",
      data_type: AttributeDataType.PICK_LIST,
      pick_list_values: AssetGroupStatusOptions.map((option) => ({
        id: option.value,
        name: option.label,
      })),
      is_required: true,
    },
    {
      field_name: "measurement_type",
      display_name: "Measurement Type",
      data_type: AttributeDataType.PICK_LIST,
      pick_list_values: NetworkMeasurementTypeOptions.map((option) => ({
        id: option.value,
        name: option.label,
      })),
      is_required: true,
    },
    {
      field_name: "reporting_group_id",
      display_name: "Reporting Scenario",
      data_type: AttributeDataType.PICK_LIST,
      pick_list_values: reportingGroups.map((option) => ({
        id: option.id,
        name: option.name,
      })),
      is_required: true,
    },
    ...customAttributes
      .sort((a, b) => Number(b.is_required) - Number(a.is_required))
      .map((custom_attribute) => {
        return {
          ...custom_attribute,
          field_name: `custom_attributes.${custom_attribute.field_name}`,
        } as typeof custom_attribute;
      }),
  ];

  return (
    <AssetDetailsFormStep
      resourceType={Resources.ASSET_GROUP}
      staticFieldsToDisplay={staticFieldsToDisplay}
    />
  );
};
